<template>
  <div>
    <h3>Edit Page Details</h3>
    <button @click="goBackToPages">Organize Pages</button>
    <div>
      <div class="warning">Note: Notes and Credits are no longer shown when viewing the album as of 2024-04-27. This edit section exists in case you want to see what you had previously typed in, so that you can copy it out to somewhere else useful.</div>
    </div>
    <div class="pagecontainer">
      <div class="page" v-for="pageState of pagesState" :key="pageState.model.id">
        <div class="layout"><img class="pic" :src="pageState.model.thumbnailUrl" /></div>
        <div class="layoutdetailscontainer">
          <vue-form :state="pageState.formstate" @submit.prevent="onSubmit">
            <div class="layoutdetails">
              <div class="layoutnotes">
                <validate tag="label">
                  <div>
                    <div class="layoutnotestitle">Notes</div>
                    <div class="layoutnotesinput">
                      <textarea v-model="pageState.model.notes" name="notes" @blur="save(pageState)" />

                      <field-messages name="notes">
                        <div>&nbsp;</div>
                      </field-messages>
                    </div>
                  </div>
                </validate>
              </div>

              <div class="layoutcredits">
                <validate tag="label">
                  <div>
                    <div class="layoutcreditstitle">Credits</div>
                    <div class="layoutcreditsinput">
                      <textarea v-model="pageState.model.credits" name="credits" @blur="save(pageState)" />

                      <field-messages name="credits">
                        <div>&nbsp;</div>
                      </field-messages>
                    </div>
                  </div>
                </validate>
              </div>
            </div>

            <div class="status">
              <div class="saving" v-if="pageState.saving"><em>Saving...</em></div>
              <div class="success" v-if="pageState.saved">Saved!</div>
              <div class="error">{{pageState.saveError}}</div>
            </div>
          </vue-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { albumPages } from '../utils/routing'
import { orderPages } from '../utils'
export default {
  props: ['album'],
  data() {
    return {
      pagesState: orderPages(this.album.pages, this.album.pageOrders).map(x => ({
        formstate: {},
        model: {
          id: x.id,
          notes: x.notes,
          credits: x.credits,
          thumbnailUrl: x.thumbnailUrl,
        },
        saving: false,
        saved: false,
        saveError: null,
      })),
    }
  },
  methods: {
    save(pageState) {
      if (pageState.formstate.$valid) {
        pageState.saveError = null
        pageState.saving = true
        axios.patch('/api/pages/' + pageState.model.id, pageState.model).then(() => {
          pageState.saved = true
          pageState.formstate._reset()
          setTimeout(() => pageState.saved = false, 2000)
        }).catch(error => {
          pageState.saveError = "There was an error while saving: " + error.message
        }).then(() => {
          pageState.saving = false
        })
      }
    },
    goBackToPages() {
      this.$router.push(albumPages(this.album))
    },
  },
}
</script>

<style lang="stylus" scoped>
.pagecontainer
  margin-top 20px

.page
  border-bottom 1px solid #ededed
  padding-bottom 20px
  margin-bottom 25px
  display flex

  .layout
    margin-right 25px
    width 135px

  .pic
    max-width 128px

.layoutdetailscontainer
  display flex
  flex 1

  form
    flex 1

  .layoutdetails
    display flex
    flex 1

    > div
      flex 1

    .layoutnotes div, .layoutcredits div
      display flex

      &.layoutnotestitle, &.layoutcreditstitle
        width 65px

      &.layoutnotesinput, &.layoutcreditsinput
        flex 1

        textarea
          width 90%
          height 150px

label
  font-weight bold

  .hint
    font-weight normal
    font-size small
    font-style italic

  &.vf-field-invalid
    > div
      font-weight bold
      color palevioletred

.status
  font-weight bold

  .success
    color mediumseagreen

  .error
    color palevioletred

.warning
  background #f57b36
  padding 10px
  display inline-block
  border-radius 3px
</style>
